// extracted by mini-css-extract-plugin
export var progressBar = "_nn-0";
export var progressBarInner = "_nn-1";